module.exports = __webpack_public_path__ + "static/media/img6.ab9371d6.jpg";